import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseQueryParams, IResponse, IResponsePaginate, DelaisReglementaires, DelaisReglementairesDto } from '@/types';

interface DelaisReglementairesQuery extends BaseQueryParams {
  typeMarcherId?: number;
  modePassationId?: number;
  search?: string;
  page?: number;
  size?: number;
}

@Injectable({
  providedIn: 'root',
})
export class DelaisReglementairesService {
  BASEURL = `${environment.api.paramsUrl}/delais-reglementaires`;
  httpClient = inject(HttpClient);

  getDelaisReglementaires(params?: DelaisReglementairesQuery): Observable<IResponsePaginate<DelaisReglementaires>> {
    return this.httpClient.get<IResponsePaginate<DelaisReglementaires>>(`${this.BASEURL}`, { params: params as HttpParams });
  }

  getOneDelaisReglementaires(typeMarcherId: number, modePassationId: number): Observable<IResponse<DelaisReglementaires>> {
    return this.httpClient.get<IResponse<DelaisReglementaires>>(`${this.BASEURL}/${typeMarcherId}/${modePassationId}`);
  }

  addDelaisReglementaires(delaisReglementaires: DelaisReglementairesDto): Observable<IResponse<DelaisReglementaires>> {
    return this.httpClient.post<IResponse<DelaisReglementaires>>(`${this.BASEURL}`, delaisReglementaires);
  }

  updateDelaisReglementaires(delaisReglementaires: DelaisReglementairesDto): Observable<IResponse<DelaisReglementaires>> {
    return this.httpClient.put<IResponse<DelaisReglementaires>>(`${this.BASEURL}`, delaisReglementaires);
  }

  deleteDelaisReglementaires(typeMarcherId: number, modePassationId: number): Observable<IResponse<DelaisReglementaires>> {
    return this.httpClient.delete<IResponse<DelaisReglementaires>>(`${this.BASEURL}/${typeMarcherId}/${modePassationId}`);
  }
}
